import { Component, OnInit } from '@angular/core';
import { AmbitService } from '../ambit.service';
import * as firebase from 'firebase';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cities',
  templateUrl: './cities.component.html',
  styleUrls: ['./cities.component.css']
})
export class CitiesComponent implements OnInit {

  public cityList: any = [];
  public stopList: any = [];
  public submitted: boolean = false;
  public cityName: any = '';
  public searchList: any = ['name'];
  public sortColumn:any = 'name';
  public sortType:boolean = false ;
  public count = 0;
  public loading:boolean = false;
  public cityCheckedList:any = [];
  public selectAll: boolean = false ;

  constructor(public service:AmbitService,
    public router: Router) { 
    if(this.service.adminUser.userAccess.cities =='None') {
      this.router.navigate(['/home']);
    }
  }

  ngOnInit() {
   this.getCityData();
  }

  getCityData(){
    var self = this;

    firebase.database().ref().child('Cities')
      .once('value', function (snapshot) {
        self.cityList = [];
        var data = snapshot.val();
        if (data) {
          for (var key in data) {
            data[key].cityID = key;
            data[key].name = data[key].name.toUpperCase();
            self.cityList.push(data[key]);
          }
        }
      });

      firebase.database().ref().child('Stops')
      .once('value', function (snapshot) {
        self.stopList = [];
        var data = snapshot.val();
        if (data) {
          for(var key in data) {
            data[key].stopID = key ;
            self.stopList.push(data[key]);
          }
        }
      });

  }

  countCity(cityID){
    var count=0;
    if(!this.stopList.length){
      return count;
    } else {
    for(var i=0; i<this.stopList.length ; i++) {
      if(this.stopList[i].cityID == cityID ) {
        count ++ ;
      }
    }
    return count;
  }
   
  }

  toggleSortValue(val) {
    if(this.sortColumn==val){
      this.sortType = !this.sortType ;
    } else {
      this.sortColumn = val;
    }
  }

  onSelectCity(cityID, isChecked: boolean) {
 
    if(cityID=='All' && !isChecked) {
      this.selectAll = false ; 
      this.cityCheckedList = [] ;
    } else if(cityID=='All' && isChecked) {
      this.selectAll = true ; 
      this.cityCheckedList = [] ;
      for(var i=0; i<this.cityList.length; i++) {
        this.cityCheckedList.push( this.cityList[i].cityID);
      }
    } else {
      if (isChecked) {
        this.cityCheckedList.push(cityID);
        if(this.cityCheckedList.length == this.cityList.length) {
          this.selectAll = true;
         }
       } else {
         this.cityCheckedList.splice(this.cityCheckedList.indexOf(cityID),1);
         if(!this.cityCheckedList.length || this.cityCheckedList.length != this.cityList.length) {
          this.selectAll = false;
         }
         
       } 
    }
    
  }

  addNewCity() {
 
    var self=this ;
    self.submitted = true;
    self.loading = true;
    if (self.cityName) {

      self.submitted = false;
      var formData = {
        name: self.cityName,
        active: true,
        timeStamp: firebase.database.ServerValue.TIMESTAMP,
      };

      var newCityID = firebase.database().ref().child('Cities/').push().key;
  
      var updates = {};
      updates['/Cities/' + "/" + newCityID] = formData;
      firebase.database().ref().update(updates).then(() => {
      // firebase.database().ref('Cities').push(formData).then((result) => {
        formData['cityID'] = newCityID ;
        self.cityList.unshift(formData);
        document.getElementById('addCityClose').click();
        self.loading =false;
      }).catch((err) => {
        self.loading =false;
        alert(err);
      });
    }
  }

  updateCity(check, key) {

    var self = this;
    var data = self.cityList.find(ob => ob['cityID'] === key)
    var updateData: any = {};
    updateData['Cities/' + key] = data;
    if (check == 'city') {
      updateData['Cities/' + key].name = self.cityName ;
    } else if (check == 'status') {
      if (data.active) {
        updateData['Cities/' + key].active = false;
      } else {
        updateData['Cities/' + key].active = true;
      }

    }

    firebase.database().ref().update(updateData).then(() => {
      self.getCityData();
      if (check == 'city') {
        document.getElementById('addCityClose').click();
      } else if (check == 'status') {
        document.getElementById('closeStatusMd').click();
      }

    });

  }

  removeCityStops() {
    var self=this;
      self.loading = true;
      var countJ=0;
      for( var j=0; j<self.stopList.length ; j++) {
        
        if(self.cityCheckedList.indexOf(self.stopList[j].cityID) >=0 ) {
          firebase.database().ref('Stops/' + self.stopList[j].stopID).remove().then(() => {
           countJ++;
            if(countJ>=self.stopList.length) {
          
             self.removeCities();
            }
          }).catch((err) => {
            self.loading = false;
            alert(err);
          });
        } else {
          
          countJ ++ ;
          if(countJ>=self.stopList.length) {
        
            self.removeCities();
          }
        }
      }
    }

    removeCities() {
      var self=this;
      
        var countI=0;
        for( var i=0; i<self.cityList.length ; i++) {
       
          if(self.cityCheckedList.indexOf(self.cityList[i].cityID) >=0 ) {
            firebase.database().ref('Cities/' + self.cityList[i].cityID).remove().then(() => {
              countI++;
              if(countI>=self.cityList.length) {
              
                document.getElementById('delCityMd').click();
               self.getCityData();
              }
              
            }).catch((err) => {
              self.loading = false;
              alert(err);
            });
          } else {
            countI ++ ;
            if(countI>=self.cityList.length) {
              self.loading = false;
              document.getElementById('delCityMd').click();
              self.getCityData();
            }
          }
        }
      }
   
}
